module.exports = __webpack_public_path__ + "assets/192837136d3aa2f11709fb4d90bb35be.mp3";